export class ConnectionTypeModel {
    public conId: number;
    public connName: string;
 }


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/connetionType/connection.type.model.ts